import React from 'react';
import { Form, DatePicker as AntdDatePicker } from 'antd';
import { FormItemLayout } from 'antd/es/form/Form';
import { Rule } from 'antd/es/form';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/lv';
import lv_LV from 'antd/es/date-picker/locale/lv_LV';
import { Validations } from '../../interfaces';
import useFormValidation from '../../utils/useFormValidation';
import { useBreakpoint } from 'utils/useBreakpoint';

dayjs.locale('lv');

export interface DatePickerProps extends Validations {
  size?: 'large' | 'middle' | 'small' | undefined;
  placeholder?: string;
  onChange?: (date: Dayjs, dateString: string | string[]) => void;
  disabled?: boolean;
  readOnly?: boolean;
  value?: Dayjs;
  picker?: any;
  format?: string;
  name?: (string | number)[] | string | number;
  label?: string;
  disabledDate?: (date: Dayjs) => boolean;
  disabledTime?: (date: Dayjs) => {
    disabledHours?: () => number[];
    disabledMinutes?: (selectedHour?: number) => number[];
    disabledSeconds?: (selectedHour?: number, selectedMinute?: number) => number[];
  };
  initialValue?: Dayjs;
  className?: string;
  suffixIcon?: JSX.Element;
  layout?: FormItemLayout;
  showTime?: boolean | object;
  needConfirm?: boolean;
  rules?: Rule[];
}

export const DatePicker = ({
  className,
  placeholder = '',
  onChange,
  disabled,
  readOnly,
  validations,
  value,
  size = 'large',
  picker,
  format = 'DD.MM.YYYY',
  name,
  label,
  disabledDate,
  disabledTime,
  initialValue,
  suffixIcon,
  layout,
  showTime,
  needConfirm,
  rules: customRules,
}: DatePickerProps) => {
  const { formValidations } = useFormValidation();
  const { isMdDown } = useBreakpoint();

  const validationRules = validations ? formValidations(validations) : [];
  const rules = customRules
    ? [...validationRules, ...customRules]
    : validationRules;

  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={initialValue}
      rules={rules}
      layout={layout}
    >
      <AntdDatePicker
        className={className}
        getPopupContainer={(triggerNode: HTMLElement) => triggerNode}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        inputReadOnly={readOnly || isMdDown}
        open={readOnly ? false : undefined}
        allowClear={readOnly ? false : undefined}
        value={value}
        size={size}
        format={format || 'DD.MM.YYYY'}
        picker={picker}
        disabledDate={disabledDate}
        disabledTime={disabledTime}
        locale={lv_LV}
        showTime={showTime}
        needConfirm={needConfirm}
      />
    </Form.Item>
  );
};
